import React from 'react';
import './style.css';
import Navbar from './Navbar';
import Landing from './Landing';


function MainPage() {
  return (
    <>
      <Navbar/>
      <Landing/>
    </>
  )
}

export default MainPage;